<template>

<div class="bullet text-block">

	<div class="bullet-icon"></div>
	<h3 class="bullet-text" v-html="$nl2br(item.content)"></h3>

</div>

</template>

<script>

export default {

	props: ['item']

}

</script>

<style scoped>

.bullet {
	display: flex;
	flex-direction: row;
}

.bullet-icon {
	width: 20px;
	height: 20px;
	margin-right: 10px;
	flex-shrink: 0;
	background-size: 20px 20px;
	background-position: 50% 50%;
	background-repeat: no-repeat;
	background-image: url(~@/assets/text/stop.svg);
}

.bullet-text {
	color: #707070;
	font-size: 18px;
	flex-grow: 1;
	line-height: 24px;
	margin-bottom: 5px;
}

.bullet-text >>> a {
	color: #4082d3;
}

</style>
